// Simple environment-aware logger that silences output in production
// Usage: import { logger } from './logger'; logger.warn('message');

const isDev = typeof import.meta !== 'undefined' && Boolean(import.meta.env?.DEV);

function safeCall(method, args) {
  try {
    // Only log in development to avoid noisy consoles in production
    if (!isDev) return;
     
    console[method](...args);
  } catch (e) { void e;
  }
}

export const logger = {
  log: (...args) => safeCall('log', args),
  warn: (...args) => safeCall('warn', args),
  error: (...args) => safeCall('error', args),
  debug: (...args) => safeCall('debug', args),
};

export default logger;
